import styled from 'styled-components/macro';

import { ThemedCircleButton } from 'components/ThemedCircleButton';
import { ReactComponent as PhoneSvg } from 'components/svg/Phone.svg';
import { large } from 'styles/breakpoints';
import { IWithThemeProps } from 'typings';

export const Logo = styled.div`
  display: none;
  height: 150px;
  margin: 30px auto;
  width: 302px;

  ${({ theme }: IWithThemeProps) => `
    background: center / contain url(${theme.logoUrl}) no-repeat;
  `}

  ${large`
    width: 386px;
    display: block;
  `}
`;

export const PhoneSvgStyled = styled(PhoneSvg)`
  ${({ theme }: IWithThemeProps) => `
    [data-svg-class="Icon"] {
      stroke: ${theme.bottomForegroundActionPrimary};
    }
  `}
`;

export const CircleButtonStyled = styled(ThemedCircleButton)`
  display: flex;
  margin: 30px auto;

  ${large`
    display: none;
  `}
`;
